<template>
	<div class="transfer">
		<div class="transfer__col fields">
			<div class="fields__item field-input">
				<div class="field-input__label"> Укажите сумму перевода, максимальная сумма 5000 рублей. </div>
				<input v-model="data.amount" type="text" id="amount" class="field-input__input" placeholder="Сумма">
			</div>
			<div class="fields__item field-input">
				<div class="field-input__label">Укажите пожалуйста ID получателя или имя пользователя</div>
				<input v-model="data.user" type="text" id="user" class="field-input__input" placeholder="ID или username пользователя">
			</div>
			<div class="fields__item field-input">
				<div class="field-input__label">Дополнительная информация к переводу</div>
				<input v-model="data.comment" type="text" id="comment" class="field-input__input" placeholder="Комментарий">
			</div>
			<button
				@click="transfer()"
				:disabled="disableButton"
				type="submit" class="btn">
				Перевести
			</button>
		</div>
		<div class="transfer__col">
			<div class="table" v-if="Object.keys(transfers).length">
				<table>
					<thead>
						<tr>
							<th scope="col">Пользователь</th>
							<th scope="col">Сумма</th>
							<th scope="col">Дата</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(transfer) in transfers">
							<td class="transfer__user-td" :class="[transfer.sender ? 'up': '']">
								{{ transfer.sender ? transfer.to.username : transfer.from.username }}
								<svg class="table__th-icon">
									<use href="#svg-icon-chevron"></use>
								</svg>
								<small v-if="transfer.comment" class="transfer__user-comment">
									{{ transfer.comment }}
								</small>
							</td>
							<td>{{ Number(transfer.amount).toFixed(2) }} ₽</td>
							<td>{{ transfer.datetime }}</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div class="page-title" v-else>
				<h4>Вы ещё не произвели ни одного перевода</h4>
			</div>
		</div>
	</div>
</template>

<script>

	import { mapState } from 'pinia';
	import { useUserStore } from './../../stores/User';
	import {nextTick} from "vue";

    export default {

        data() {
            return {
                transfers: [],
                data: {
                    amount: '',
                    user: null,
                    comment: null
                },
                isValid: true,
                error: {
                    show: false,
                    message: ''
                },
                success: {
                    show: false,
                    message: ''
                },
                disableButton: false
            }
        },
        created() {
            this.$root.isLoading = true;

			if(!this.user || !this.user.is_admin || !this.user.can_transfer) {
				this.$router.go(-1);
			} else {
				setTimeout(this.get, 111);
			}
        },

		computed: {
			...mapState(useUserStore, ['user'])
		},

        methods: {
            validate() {
                this.isValid = true;
                this.disableButton = true;
                this.data.amount = Number(this.data.amount).toFixed(2);

                if(isNaN(this.data.amount) || this.data.amount > 5000 || this.data.amount < 10) {
                    this.isValid = false;
                    this.$toast.error('Введите сумму от 10 до 5000');
                }

                if(this.data.user === '') {
                    this.isValid = false;
                    this.$toast.error('Укажите пожалуйста ID получателя или имя пользователя');
                }

                this.disableButton = false;

                return this.isValid;
            },
            get() {
                this.$root.axios.get('/api/transfers')
                .then(res => {
                    this.transfers = res.data.transfers;
                })
				.finally(() => this.$root.isLoading = false)
            },
            transfer() {
                if(!this.validate()) return;

                this.$root.axios.post('/api/transfers/send', this.data)
                .then(res => {
                    this.$toast.success(res.data.message);
                    this.user.balance = res.data.balance;

					setTimeout(this.get, 111);
                }).catch(error => {
                    this.$toast.error(this.$root.graphql.axiosGetError(error));
                });
            },
        }
    }
</script>
